/**
 * Centralized Dark Mode Color Palette
 * Use these constants for consistent dark mode styling across the application
 */

export const DARK_MODE_COLORS = {
  // Backgrounds
  bg: {
    primary: '#1a1f2e', // Main sidebar and card background
    secondary: '#2b3544', // Page background
    tertiary: '#242b3d', // Hover states, elevated elements
  },

  // Borders
  border: {
    default: '#374151', // Standard borders
    subtle: '#2d3748', // Subtle dividers
  },

  // Text
  text: {
    primary: '#E5E7EB', // Main text
    secondary: '#9CA3AF', // Secondary text
    muted: '#6B7280', // Muted text
  },

  // Accents
  accent: {
    blue: '#60A5FA', // Primary blue accent
    blueDark: '#3B82F6', // Darker blue
    green: '#34D399', // Success/positive
    red: '#F87171', // Error/negative
    yellow: '#FBBF24', // Warning
  },
} as const;

export const LIGHT_MODE_COLORS = {
  bg: {
    primary: '#ffffff',
    secondary: '#f8f9fa',
    tertiary: '#f3f4f6',
  },

  border: {
    default: '#e5e7eb',
    subtle: '#f3f4f6',
  },

  text: {
    primary: '#111827',
    secondary: '#6B7280',
    muted: '#9CA3AF',
  },

  accent: {
    blue: '#3B82F6',
    blueDark: '#2563EB',
    green: '#10B981',
    red: '#EF4444',
    yellow: '#F59E0B',
  },
} as const;
